var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDownloadReportLight({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 14,
    viewBox: "0 0 12 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.25 14C11.6562 14 12 13.6875 12 13.25V12.5C12 12.0938 11.6562 11.75 11.25 11.75H0.75C0.3125 11.75 0 12.0938 0 12.5V13.25C0 13.6875 0.3125 14 0.75 14H11.25ZM4 0.75V5H1.25C0.6875 5 0.40625 5.6875 0.8125 6.09375L5.5625 10.8438C5.78125 11.0625 6.1875 11.0625 6.40625 10.8438L11.1562 6.09375C11.5625 5.6875 11.2812 5 10.7188 5H8V0.75C8 0.34375 7.65625 0 7.25 0H4.75C4.3125 0 4 0.34375 4 0.75Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownloadReportLight);
export default __webpack_public_path__ + "static/media/download-report-light.429e8d9f1ae29322a8bbb0832775d5fc.svg";
export { ForwardRef as ReactComponent };